import React from 'react';


function APagarGrid({ arrayPagar, onPagar, onDelete, onEstornar, onEdit, userPermissions }) {

    const formatarData = (isoString) => {
        if (!isoString) return '—';
        const data = new Date(isoString);
        if (isNaN(data.getTime())) return 'Inválida';
        // Ajuste para exibir a data corretamente independente do fuso horário
        const userTimezoneOffset = data.getTimezoneOffset() * 60000;
        return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(data.getTime() + userTimezoneOffset));
    };

    const formatarValor = (valor) => {
        return (Number(valor) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const getStatusClass = (status) => {
        if (status === 'Pago') {
            return 'badge-success';
        } else {
            return 'badge-warning';
        }
    };

    if (!arrayPagar || arrayPagar.length === 0) {
        return (
            <div className="financeiro-empty-state">
                <div className="financeiro-empty-icon">
                    <i className="fas fa-file-invoice-dollar"></i>
                </div>
                <h5 className="text-muted">Nenhum lançamento encontrado</h5>
                <p className="text-muted small">
                    Não há contas a pagar cadastradas ou que correspondam à sua pesquisa.
                </p>
            </div>
        );
    }

    return (
        <div className="financeiro-grid-container">
            <table className="table-custom">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '120px' }}>Ações</th>
                        <th className="text-start col-status">Status</th>
                        <th className="text-center" style={{ width: '100px' }}>Num. Doc</th>
                        <th className="text-start" style={{ width: '350px', maxWidth: '350px' }}>Fornecedor</th>
                        <th className="text-center" style={{ width: '120px' }}>Valor Total</th>
                        <th className="text-center" style={{ width: '110px' }}>Cadastro</th>
                        <th className="text-center" style={{ width: '110px' }}>Vencimento</th>
                        <th className="text-center" style={{ width: '110px' }}>Pagamento</th>
                        <th className="text-center" style={{ width: '80px' }}>Prazo</th>
                        <th className="text-start" style={{ width: 'auto', minWidth: '200px' }}>Descrição</th>
                        <th className="text-start">Usuário Cad.</th>
                        <th className="text-center" style={{ width: '110px' }}>Últ. Alt.</th>
                        <th className="text-start">Usuário Alt.</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayPagar.map((lanc) => (
                        <tr key={lanc.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <button onClick={(e) => {
                                        if (userPermissions && userPermissions['editar_financeiro_a_pagar'] === false) {
                                            e.preventDefault();
                                            import('sweetalert2').then((Swal) => {
                                                Swal.default.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                            });
                                            return;
                                        }
                                        onEdit(lanc.id);
                                    }} className="btn-action-sm btn-edit" title="Editar">
                                        <i className="fas fa-edit"></i>
                                    </button>
                                    {lanc.status === 'Em aberto' ? (
                                        <button onClick={(e) => {
                                            if (!userPermissions || !userPermissions['pagar_financeiro_a_pagar']) {
                                                e.preventDefault();
                                                import('sweetalert2').then((Swal) => {
                                                    Swal.default.fire({
                                                        icon: 'error',
                                                        title: 'Acesso Negado',
                                                        text: 'Você não tem permissão para efetuar pagamentos.',
                                                        confirmButtonColor: '#2185c6'
                                                    });
                                                });
                                                return;
                                            }
                                            onPagar(lanc.id)
                                        }} className="btn-action-sm btn-pagar" title="Marcar como Pago">
                                            <i className="fas fa-check"></i>
                                        </button>
                                    ) : (
                                        <button onClick={(e) => {
                                            if (!userPermissions || !userPermissions['estornar_financeiro_a_pagar']) {
                                                e.preventDefault();
                                                import('sweetalert2').then((Swal) => {
                                                    Swal.default.fire({
                                                        icon: 'error',
                                                        title: 'Acesso Negado',
                                                        text: 'Você não tem permissão para estornar pagamentos.',
                                                        confirmButtonColor: '#2185c6'
                                                    });
                                                });
                                                return;
                                            }
                                            onEstornar(lanc.id)
                                        }} className="btn-action-sm btn-estornar" title="Estornar Pagamento">
                                            <i className="fas fa-undo"></i>
                                        </button>
                                    )}
                                    <button onClick={() => onDelete(lanc.id)} className="btn-action-sm btn-delete" title="Excluir" disabled={lanc.status === 'Pago'}>
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                            <td className="text-start col-status" data-label="Status">
                                <span className={`financeiro-badge ${getStatusClass(lanc.status)}`}>
                                    {lanc.status}
                                </span>
                            </td>
                            <td className="text-center" data-label="Num. Doc">
                                {lanc.numero_doc || '—'}
                            </td>
                            <td data-label="Fornecedor" style={{ minWidth: '350px', maxWidth: '350px', width: '350px', display: 'table-cell', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <span className="fw-medium text-dark">{lanc.fornecedor_nome || 'Não identificado'}</span>
                            </td>
                            <td className="text-end fw-bold" data-label="Valor Total">{formatarValor(lanc.valor_total)}</td>
                            <td className="text-center" data-label="Cadastro">{formatarData(lanc.data_cadastro)}</td>
                            <td className="text-center" data-label="Vencimento">{formatarData(lanc.data_vencimento)}</td>
                            <td className="text-center" data-label="Pagamento">{formatarData(lanc.data_pagamento)}</td>
                            <td className="text-center" data-label="Prazo">{lanc.prazo ? `${lanc.prazo} d` : '-'}</td>
                            <td data-label="Descrição" style={{ width: 'auto', minWidth: '200px' }}>{lanc.descricao}</td>
                            <td data-label="Usuário Cad.">{lanc.usuario_cadastro || '-'}</td>
                            <td className="text-center" data-label="Últ. Alt.">{formatarData(lanc.data_ultima_alteracao)}</td>
                            <td data-label="Usuário Alt.">{lanc.usuario_ultima_alteracao || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default APagarGrid;
